import { atom } from "jotai";

export const isRaincheckModalOpenAtom = atom(false);
